import { createContext, useContext, type ReactNode } from 'react'
import { useJobsStream, type UseJobsStreamApi } from './useJobsStream'

// Держит поток задач смонтированным выше границы remount (key={pathname} в
// AppLayout). Иначе при каждом переключении вкладок DashboardPage пересоздаётся:
// WS закрывается, состояние сбрасывается, и на возврате REST-снапшот (он отстаёт
// от WS) на миг показывает уже удалённые задачи. Подняв стрим, мы сохраняем
// открытый сокет и актуальное состояние между переходами.
const JobsStreamCtx = createContext<UseJobsStreamApi | null>(null)

export function JobsStreamProvider({ children }: { children: ReactNode }) {
  const api = useJobsStream()
  return <JobsStreamCtx.Provider value={api}>{children}</JobsStreamCtx.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components
export function useJobsStreamContext(): UseJobsStreamApi {
  const ctx = useContext(JobsStreamCtx)
  if (!ctx) throw new Error('useJobsStreamContext must be used inside <JobsStreamProvider>')
  return ctx
}
